import * as React from "react";
import { forwardRef } from "react";
const SvgTimelineArrow = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 12, viewBox: "0 0 10 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M1.45935 7.41766L5.00018 10.9585L8.54102 7.41766M5.00018 1.04183L5.00018 10.8593", stroke: "#AEB2BC", strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgTimelineArrow);
export default ForwardRef;
